/**
 * Host classification for the three-domain Cyannect deployment (iteration 31):
 *   admin.cyannect.com  → 'admin'  — internal admin/super_admin portal
 *   app.cyannect.com    → 'app'    — shopper PWA (installable)
 *   everything else     → 'main'   — merchant marketing + brand portal
 *
 * Preview / localhost hosts also resolve to 'main' so the current dev workflow
 * (previewing everything in one shell) keeps working. Use ?host=app / ?host=admin
 * on any URL to force a specific mode for local testing.
 */

const OVERRIDE_KEY = "cyn_host_override";

export function getHostClass() {
  if (typeof window === "undefined") return "main";

  // 1. Query-string override (persisted to localStorage for the session)
  try {
    const q = new URLSearchParams(window.location.search).get("host");
    if (q === "app" || q === "admin" || q === "main" || q === "reseller") {
      window.localStorage.setItem(OVERRIDE_KEY, q);
      return q;
    }
    const stored = window.localStorage.getItem(OVERRIDE_KEY);
    if (stored === "app" || stored === "admin" || stored === "main" || stored === "reseller") return stored;
  } catch (_) {}

  // 2. Hostname-based detection
  const h = window.location.hostname.toLowerCase();
  if (h.startsWith("admin.")) return "admin";
  if (h.startsWith("app.")) return "app";
  if (h.startsWith("resellers.") || h.startsWith("reseller.")) return "reseller";
  return "main";
}

export function clearHostOverride() {
  try { window.localStorage.removeItem(OVERRIDE_KEY); } catch (_) {}
}

/** Cross-host URL builder — swaps the subdomain and preserves the path. */
export function urlOnHost(hostClass, path = "/") {
  if (typeof window === "undefined") return path;
  const cur = window.location.hostname.toLowerCase();
  // Preview / localhost — stay on same host, use ?host= override so the split still works
  const isPreview = cur.includes(".preview.emergentagent.com") || cur === "localhost" || cur.startsWith("127.");
  if (isPreview) {
    const sep = path.includes("?") ? "&" : "?";
    return path + sep + "host=" + hostClass;
  }
  const bare = cur.replace(/^admin\./, "").replace(/^app\./, "");
  const target = hostClass === "main" ? bare : `${hostClass}.${bare}`;
  return `${window.location.protocol}//${target}${path.startsWith("/") ? path : "/" + path}`;
}
